module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4108-b8badae94629d9c7e155e51a5f2e58c9.jpg";